// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { Menu, MenuItem } from '@mui/material';
import { useAuthData } from '@shared/auth';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AppLink } from '@client-app/routes/AppLink';

export const TopbarUserMenu = () => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  /* istanbul ignore next */
  const handleMenu = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };
  /* istanbul ignore next */
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { user, logout } = useAuthData();
  /* istanbul ignore next */
  const handleLogout = () => {
    logout();
  };

  return (
    <div data-testid="topbar-user-menu">
      <div onClick={handleMenu} className="flex items-center gap-2 lg:gap-4">
        <p className="hidden font-medium text-secondary-dark lg:block">
          {(user?.name as string | undefined) ?? ''}
        </p>
        <img
          src={(user?.picture as string | undefined) ?? undefined}
          alt=""
          className="size-10 rounded-full"
        />
      </div>

      <Menu
        classes={{ list: 'w-40' }}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose} component={AppLink} to="/account">
          {t('auth.my-account', { ns: 'auth' })}
        </MenuItem>
        <MenuItem onClick={handleLogout}>
          {t('auth.logout', { ns: 'auth' })}
        </MenuItem>
      </Menu>
    </div>
  );
};
